var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-static"},[_c('div',{staticClass:"page-body",domProps:{"innerHTML":_vm._s(_vm.$t('view.privacy.body'))}})])}
var staticRenderFns = []

export { render, staticRenderFns }